import firestore from "./firestore";

async function getDatabasesReferences(user) {
	if (!user) {
		alert("Error");
		return null;
	}

	const managersRef = firestore.collection("Usuarios").doc("managers");
	const managersDoc = await managersRef.get();
	const managersData = await managersDoc.data();
	const isUserManager = managersData.uids.includes(user.uid) || false;

	const userDataRef = managersRef.collection("usuarios").doc(user.uid);
	const userData = await userDataRef.get();
	if (!userData.exists) return null;
	const { db = "", isDev = false } = await userData.data();
	if (db) {
		const menuDB = firestore.collection("menu").doc(db).collection("actual");
		const parentMenuDB = firestore.collection("menu").doc(db);
		const managersDB = firestore.collection("Usuarios").doc("managers").collection("usuarios");
		const storesDB = firestore.collection("menu").doc("stores");
		const consoleDB = firestore.collection("consola");
		const settingsDB = consoleDB.doc(db); // Schedule - CashEnabled
		const ordersDB = consoleDB.doc(db).collection("actual");
		const loyaltyRewards = consoleDB.doc(db).collection("loyaltyRewards");
		const loyaltyRewardsPerLevel = consoleDB.doc(db).collection("loyaltyRewardsPerLevel").doc("rewards");
		const adminDB = firestore.collection("admin").doc("milagritoVSA1");
		const usersDB = firestore.collection("Usuarios").doc("VHSA").collection("contenido");
		return {
			menuDB,
			managersDB,
			consoleDB,
			settingsDB,
			ordersDB,
			parentMenuDB,
			isUserManager,
			isDev,
			storesDB,
			nameDB: db,
			adminDB,
			loyaltyRewards,
			loyaltyRewardsPerLevel,
			usersDB,
			firestore,
		};
	}
	return null;
}

export default getDatabasesReferences;
